/* Add-to-cart for the product upsells section.
   Posts to the cart, then hands the returned sections to Dawn's cart drawer
   or cart notification if one is on the page. Falls back to a plain form
   submit when JavaScript fails, since the markup is a real form. */

if (!customElements.get('upsell-add')) {
  customElements.define(
    'upsell-add',
    class UpsellAdd extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.button = this.querySelector('[data-upsell-submit]');
        this.feedback = this.querySelector('[data-upsell-feedback]');
        this.subscribeInput = this.querySelector('[data-upsell-subscribe]');
        this.sellingPlanInput = this.querySelector('[name="selling_plan"]');
        this.priceEl = this.querySelector('[data-upsell-price]');

        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
        if (this.subscribeInput) {
          this.subscribeInput.addEventListener('change', this.onSubscribeChange.bind(this));
          this.onSubscribeChange();
        }
      }

      get cart() {
        return (
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification') ||
          null
        );
      }

      onSubscribeChange() {
        const subscribed = this.subscribeInput.checked;

        if (this.sellingPlanInput) {
          this.sellingPlanInput.value = subscribed ? this.subscribeInput.value : '';
          this.sellingPlanInput.disabled = !subscribed;
        }

        if (this.priceEl) {
          const next = subscribed
            ? this.priceEl.dataset.subscriptionPrice
            : this.priceEl.dataset.oneTimePrice;
          if (next) this.priceEl.innerHTML = next;
        }
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.setBusy(true);
        this.setFeedback('');

        const formData = new FormData(this.form);
        const cart = this.cart;

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        try {
          const response = await fetch(`${window.routes.cart_add_url}`, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const result = await response.json();

          if (result.status) {
            this.setFeedback(result.description || result.message, true);
            return;
          }

          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(result);
          } else {
            this.refreshCartCount();
            this.setFeedback(this.dataset.addedText || 'Added to your cart.');
          }

          document.dispatchEvent(new CustomEvent('upsell:added', { detail: { item: result } }));
        } catch (error) {
          console.error(error);
          this.setFeedback(this.dataset.errorText || 'Something went wrong. Please try again.', true);
        } finally {
          this.setBusy(false);
        }
      }

      async refreshCartCount() {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;

        try {
          const response = await fetch(`${window.location.pathname}?section_id=cart-icon-bubble`);
          const text = await response.text();
          const html = new DOMParser().parseFromString(text, 'text/html');
          const fresh = html.querySelector('.shopify-section');
          if (fresh) bubble.innerHTML = fresh.innerHTML;
        } catch (error) {
          console.error(error);
        }
      }

      setBusy(busy) {
        this.button.setAttribute('aria-disabled', busy ? 'true' : 'false');
        this.button.classList.toggle('is-loading', busy);
      }

      setFeedback(message, isError) {
        if (!this.feedback) return;
        this.feedback.textContent = message || '';
        this.feedback.classList.toggle('upsell-card__feedback--error', Boolean(isError));
      }
    }
  );
}